export default function Breadcrumbs(theme) {
    return {
        MuiBreadcrumbs: {
            styleOverrides: {
                separator: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                },
                li: {
                    '& .MuiSvgIcon-root': {
                        marginRight: theme.spacing(1.5)
                    },
                    '& .MuiBox-root': {
                        marginRight: 0
                    },
                    '& .MuiTypography-root': {
                        textTransform: 'uppercase'
                    }
                }
            }
        }
    };
}
